import { deleteCookie } from "../../utils/helper";

export function isAuthenticated() {
  const login = JSON.parse(localStorage.getItem("login-response"));
  try {
    const { token } = login;
    if (!token) {
      deleteCookie("landlordUser");
      localStorage.clear();
      sessionStorage.clear();
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
}
